import { Palette } from "styles/theme"

import Tag from "./Tag"

export interface Props {
  className?: string
  color?: keyof Palette
  iconColor?: keyof Palette
  label: string
  onClick?: () => void
  onRemove?: () => void
}

export interface ComponentProps extends Props {}

export default Tag
